// TypesFournisseurs.js
import React from "react";
import TierTypes from "./TierTypes";

const TypesFournisseurs = () => {
    return <TierTypes title="Types de Fournisseurs" category={1} />;
};

export default TypesFournisseurs;
